<template>
  <v-container>
    <div class="back-plot">
      <!-- BOC:[error] -->
      <ApiErrorDialog v-if="api.isError" :api="api" />
      <!-- EOC -->
      <v-card class="transparent" elevation="0" v-if="classroom">
        <v-card-title class="text-h5 grey lighten-5 rounded-lg py-2">
          <v-row>
            <v-col cols="9" class="d-flex rounded align-center">
              {{ auth.User.name }}
            </v-col>
            <v-col cols="3" class="d-flex align-center justify-end">
              <CloseBtn size="40" :callback="exit" />
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
      <!-- EOC -->
      <v-card
        :class="
          settings.graphics && settings.graphics.mode == 'low'
            ? 'low_plot'
            : 'plot'
        "
        :loading="api.isLoading"
      >
        <v-card-title>{{ $t("action.linkPlayer") }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="mochiId"
            label="Mochi ID"
            placeholder="Mochi ID"
            color="green"
            filled
            rounded
            dense
          ></v-text-field>
          <v-btn
            color="green lighten-1"
            large
            @click="next"
            :loading="api.isLoading"
            block
            rounded
            class="text-h6 mb-4"
            style="text-transform: capitalize"
          >
            {{ $t("action.next") }}
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
  },
  computed: mapState({
    auth: (state) => state.auth.data,
    settings: (state) => state.settings.data,
  }),
  props: [
    //
  ],
  data: () => ({
    mochiId: "",
    code: null,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    classroom: {},
    //EOC
  }),
  created() {
    //
  },
  mounted() {
    if (this.auth.User.RequestPlayerLink) {
      this.$router.push({
        name: "PageAccessMochiIdLinkStatus",
      });
    }
    if (this.auth.Group) {
      this.code = this.auth.Group.code;
      if (this.auth && this.auth.Classroom) {
        this.classroom = this.auth.Classroom;
      }
    } else {
      this.$router.push({ name: "PageAccessMain" });
    }
  },
  methods: {
    exit() {
      this.$router.push({
        name: "PageAccessOnboardingAvatar",
      });
    },
    next() {
      this.requestLink();
    },
    requestLink() {
      this.api.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/player/requestPlayerLink/send";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        var authData = this.$_.cloneDeep(this.auth);
        authData.User.RequestPlayerLink = resp;
        this.$store.commit("updateAuth", authData);
        this.$router.push({
          name: "PageAccessMochiIdLinkStatus",
        });
      };
      this.api.params = {
        mochiId: this.mochiId,
        studentId: this.auth.Group.type == "family" ? null : this.auth.User.id,
        userId: this.auth.Group.type == "family" ? this.auth.User.id : null,
      };
      this.$api.fetch(this.api);
    },
  },
};
</script>

<style scoped>
.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}

.image1 {
  position: absolute;
  z-index: 2;
}
.image2 {
  position: absolute;
  z-index: 3;
}

.image3 {
  position: absolute;
  z-index: 1;
}

.title {
  pointer-events: none;
  font-size: 1em !important;
}
</style>